// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"22":"92c2dca8","119":"b8ecabfa","235":"1659d7b7","355":"01d9d0a0","775":"659b64b1","937":"18096848"}[chunkId] + ".css";
};